/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCellularNoSignal = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 22H2.136L22 1.534V22zM6.864 20H20V6.466L6.864 20zM9.707 3.707 7.414 6l2.293 2.293-1.414 1.414L6 7.414 3.707 9.707 2.293 8.293 4.586 6 2.293 3.707l1.414-1.414L6 4.586l2.293-2.293 1.414 1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCellularNoSignal as CellularNoSignal };
